import { isNil } from 'es-toolkit';
import { DEFAULT_VALUE_IF_NIL } from '@clearverify/constants';
export const stringifyBoolean = (value) => {
    if (isNil(value))
        return undefined;
    return value ? 'true' : 'false';
};
export const parseStringifiedBoolean = (value) => {
    return value === 'true';
};
export const parseBooleanToString = (value, variant) => {
    if (isNil(value)) {
        return DEFAULT_VALUE_IF_NIL;
    }
    switch (variant) {
        case 'true/false': {
            return value ? 'True' : 'False';
        }
        case '1/0': {
            return value ? 1 : 0;
        }
        default: {
            return value ? 'Yes' : 'No';
        }
    }
};
//# sourceMappingURL=boolean.js.map